import {Component, Input} from '@angular/core';
import {DateHelperService} from '../../../../shared/services/general';
import {PatientEditable, PatientSearch} from '../../models/order-entry/patient';
import * as moment from 'moment';

@Component({
  selector: 'app-patient-info-popup',
  templateUrl: './patient-info-popup.component.html',
  styleUrls: ['./patient-info-popup.component.scss'],
})
export class PatientInfoPopupComponent {
  @Input() public selectedPatient?: PatientSearch | PatientEditable;
  public patientInfoVisible = false;

  constructor(public dateHelper: DateHelperService) {
  }

  public togglePatientInfo() {
    this.patientInfoVisible = !this.patientInfoVisible;
  }

  get PatientCode(): string {
    return this.selectedPatient ? this.selectedPatient.code : '';
  }

  get PatientPrimaryPhysician(): string {
    return this.selectedPatient && (this.selectedPatient as any).primaryPhysician ?
      (this.selectedPatient as any).primaryPhysician.lastName + ', ' + (this.selectedPatient as any).primaryPhysician.firstName : '';
  }

  get PatientBirthDate(): string {
    return this.selectedPatient ? moment(this.selectedPatient.birthDate).format('LL') : '';
  }

  get PatientGender(): string {
    return this.selectedPatient ? this.selectedPatient.gender : '';
  }

  get PatientSSN(): string {
    return this.selectedPatient ? this.selectedPatient.socialSecurityNumber : '';
  }

  get PatientAddress(): string {
    return this.selectedPatient
      ? `${this.selectedPatient.address}
      ${this.selectedPatient.zipCode ? '. ' + this.selectedPatient.zipCode.city : ''}
      ${this.selectedPatient.zipCode ? ', ' + this.selectedPatient.zipCode.state : ''}
      ${this.selectedPatient.zipCode ? ', ' + this.selectedPatient.zipCode.code : ''}`
      : '';
  }
}
